var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_799_4600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 0C10.7456 0 0 10.7447 0 24C0 37.2553 10.7456 48 24 48C37.2544 48 48 37.2544 48 24C48 10.7456 37.2544 0 24 0Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.68806e-05 24C-0.00650938 28.3577 1.17909 32.6342 3.42846 36.3666C5.97597 37.171 8.63196 37.5792 11.3035 37.5769C25.7063 37.5769 37.3819 25.9012 37.3819 11.4994C37.3842 8.69083 36.9321 5.90041 36.0432 3.23625C32.3861 1.11032 28.2301 -0.00647388 24 -2.5531e-06C10.7457 -2.5531e-06 2.68806e-05 10.7447 2.68806e-05 24Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 7.03125C25.5029 7.03125 26.9722 7.47695 28.2219 8.31198C29.4716 9.14701 30.4457 10.3339 31.0208 11.7225C31.596 13.1111 31.7465 14.6391 31.4533 16.1132C31.1601 17.5873 30.4363 18.9414 29.3735 20.0042C28.3107 21.067 26.9566 21.7908 25.4825 22.084C24.0084 22.3772 22.4804 22.2267 21.0918 21.6515C19.7032 21.0764 18.5163 20.1023 17.6813 18.8526C16.8462 17.6029 16.4006 16.1336 16.4006 14.6306C16.4006 12.6151 17.2012 10.6822 18.6264 9.25706C20.0515 7.8319 21.9844 7.03125 23.9999 7.03125ZM33.4893 39.9094C27.2408 41.3119 20.7591 41.3119 14.5106 39.9094C11.5284 39.1594 9.5418 35.5125 10.7334 33.0656C12.9581 28.44 18.0759 24.3778 23.9999 24.3394C29.923 24.3787 35.0418 28.44 37.2656 33.0656C38.4571 35.5172 36.4687 39.1594 33.4893 39.9131V39.9094Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_799_4600"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileAvatar);
export default __webpack_public_path__ + "static/media/profile_avatar.01c5e0dec96de36143171c14987651b6.svg";
export { ForwardRef as ReactComponent };